import { Component, OnInit, Inject } from '@angular/core';
import { Router } from '@angular/router';
import { LoginService } from '../../core/services/login.service';
import { ViewStateService } from '../../core/services/view-state.service';

@Component({
  selector: 'app-root-redirect',
  template: '',
  standalone: false,
})
export class RootRedirectComponent implements OnInit {
  constructor(
    @Inject(Router) private router: Router,
    @Inject(LoginService) private loginService: LoginService,
    @Inject(ViewStateService) private viewState: ViewStateService
  ) {}

  ngOnInit() {
    // Wait for login check to complete
    this.loginService.promise.then(() => {
      if (this.loginService.getLoginState().isLoggedIn) {
        this.router.navigateByUrl(this.viewState.getLastRouteOrFallback());
      } else {
        this.router.navigate(['/login']);
      }
    });
  }
}
